/* eslint-disable import/prefer-default-export */
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'use-http';
import { ServerContext } from '@bingads-webui-campaign-react/server-context';
import { getDefaultOptions, getDefaultUrl } from './config';

export function MmpFetchProvider({ url, options, children }) {
  const serverContext = useContext(ServerContext);
  const finalOptions = getDefaultOptions(serverContext);

  if (options && options.headers) {
    finalOptions.headers = { ...finalOptions.headers, ...options.headers };
  }

  const finalUrl = url || getDefaultUrl(serverContext);

  return (
    <Provider url={finalUrl} options={finalOptions}>
      {children}
    </Provider>
  );
}

MmpFetchProvider.propTypes = {
  url: PropTypes.string,
  options: PropTypes.shape({
    headers: PropTypes.shape({}),
  }),
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};

MmpFetchProvider.defaultProps = {
  url: undefined,
  options: undefined,
};
